import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {PaperChatWebsocketDTO, PaperChatWebsocketState} from '../../dto/paper-chat';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {NgOptimizedImage} from '@angular/common';
import {ResearchPaperDTO} from '../../../research/dto/research-paper';
import {CustomMarkdownComponent} from '../markdown/markdown.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {
  ResearchPaperCardComponent
} from '../../../research/components/research-paper-card/research-paper-card.component';

@Component({
  selector: 'app-paper-chat-receiving-bubble',
  imports: [MatProgressBarModule, NgOptimizedImage, CustomMarkdownComponent, MatExpansionModule, MatIconModule, ResearchPaperCardComponent],
  templateUrl: './paper-chat-receiving-bubble.component.html',
  styleUrl: './paper-chat-receiving-bubble.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaperChatReceivingBubbleComponent implements OnChanges {
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef)
  readonly message = input<PaperChatWebsocketDTO>();
  readonly papers = input<ResearchPaperDTO[] | null>();
  readonly isSmallScreen = input<boolean>(false);

  messageText: string | null = null;
  usedPapers: ResearchPaperDTO[] = [];
  useLoading: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["message"]) {
      if (changes["message"].currentValue.state === PaperChatWebsocketState.START) {
        this.useLoading = true;
      }
      if (changes["message"].currentValue.state === PaperChatWebsocketState.END) {
        this.useLoading = false;
      }
      this.cdr.detectChanges();
    }
  }

  applyFlow = effect(() => {
    const message = this.message();
    if (!message || !message.message) {
      return;
    }
    if (message.message.includes("**Sources**[")) {
      const messageParts = message.message.split("**Sources**");
      const paperIds = messageParts[1].replace("[", "").replace("]", "").split(",");
      this.usedPapers = paperIds.map(id => this.getPaper(+id)!).filter(paper => !!paper);
      this.messageText = messageParts[0];
    } else {
      this.messageText = message.message;
    }
    this.cdr.detectChanges();

  });

  getPaper(paperId: number): ResearchPaperDTO | undefined {
    if (!paperId || !this.papers()) {
      return undefined;
    }
    return this.papers()!.find(source => source.id === paperId);
  }

}
